export class TaskApi {
  public title: string = 'test';
  public category_id: number = 2;
  public description: string;
  public count: number = 1;
  public done: number = 0;
}
